// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const _map = {"s":"s","m":"m","l":"l"};

function sizeToJs(param) {
  return param;
}

function sizeFromJs(param) {
  return _map[param];
}

function make(className) {
  return function (valueOpt) {
    const value = valueOpt !== undefined ? valueOpt : "";
    return function (placeholderOpt) {
      const placeholder = placeholderOpt !== undefined ? placeholderOpt : "";
      return function (type_Opt) {
        const type_ = type_Opt !== undefined ? type_Opt : "text";
        return function (disabledOpt) {
          const disabled = disabledOpt !== undefined ? disabledOpt : false;
          return function (readOnlyOpt) {
            const readOnly = readOnlyOpt !== undefined ? readOnlyOpt : false;
            return function (requiredOpt) {
              const required = requiredOpt !== undefined ? requiredOpt : false;
              return function (isFocusedOpt) {
                const isFocused = isFocusedOpt !== undefined ? isFocusedOpt : false;
                return function (darkModeOpt) {
                  const darkMode = darkModeOpt !== undefined ? darkModeOpt : false;
                  return function (onKeyPress) {
                    return function (onChangeOpt) {
                      const onChange = onChangeOpt !== undefined ? onChangeOpt : (function (param) {
                            
                          });
                      return function (onFocusOpt) {
                        const onFocus = onFocusOpt !== undefined ? onFocusOpt : (function (param) {
                              
                            });
                        return function (onBlurOpt) {
                          const onBlur = onBlurOpt !== undefined ? onBlurOpt : (function (param) {
                                
                              });
                          const className$1 = Cn.fromList({
                                hd: Cn.on("text-white bg-black", darkMode),
                                tl: {
                                  hd: Cn.take(className),
                                  tl: {
                                    hd: "text-sm box-border w-full",
                                    tl: /* [] */0
                                  }
                                }
                              });
                          const inputRef = React.useRef(null);
                          React.useEffect((function () {
                                  if (isFocused) {
                                    const __x = inputRef.current;
                                    Belt__Belt_Option.map((__x == null) ? undefined : Caml_option.some(__x), (function (el) {
                                            return el.focus();
                                          }));
                                  }
                                  
                                }), [
                                isFocused,
                                inputRef
                              ]);
                          let tmp = {
                            ref: inputRef,
                            className: className$1,
                            disabled: disabled,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: required,
                            type: type_,
                            value: value,
                            onFocus: (function (param) {
                                Curry._1(onFocus, undefined);
                              }),
                            onBlur: (function (param) {
                                Curry._1(onBlur, undefined);
                              }),
                            onChange: (function (ev) {
                                Curry._1(onChange, ev.target.value);
                              })
                          };
                          if (onKeyPress !== undefined) {
                            tmp.onKeyPress = Caml_option.valFromOption(onKeyPress);
                          }
                          return JsxRuntime.jsx("input", tmp);
                        };
                      };
                    };
                  };
                };
              };
            };
          };
        };
      };
    };
  };
}

function Input(Props) {
  return Curry.app(make(Props.className)(Props.value), [
              Props.placeholder,
              Props.type_,
              Props.disabled,
              Props.readOnly,
              Props.required,
              Props.isFocused,
              Props.darkMode,
              Props.onKeyPress,
              Props.onChange,
              Props.onFocus,
              Props.onBlur
            ]);
}

const make$1 = Input;

export {
  sizeToJs ,
  sizeFromJs ,
  make$1 as make,
}
/* react Not a pure module */
